import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="footer">
    <div className="footer-main">
      <div className="footer-brand-block">
        <a className="footer-brand" href="#top">
          <span className="brand-mark" aria-hidden="true" />
          <span className="brand-text">Elevate</span>
        </a>
        <p>Boutique advisory for landmark residences, private villas and off-plan investments.</p>
      </div>

      <nav className="footer-nav" aria-label="Footer navigation">
        <Link to="/">Home</Link>
        <Link to="/new-projects">Properties</Link>
        <Link to="/services">Services</Link>
        <Link to="/about">About</Link>
        <Link to="/contact-us">Contact</Link>
      </nav>

      <div className="footer-contact">
        <p className="footer-kicker">Get in touch</p>
        <a href="tel:+97145586224"><span>Office</span> · +971 4 558 6224</a>
        <a href="tel:+971507135432"><span>Mobile</span> · +971 50 713 5432</a>
        <a href="mailto:connect@elevaterealtyuae.com">connect@elevaterealtyuae.com</a>
       <div className="footer-social" aria-label="Social links">
  <a
    className="footer-social-text"
    href="https://www.facebook.com/profile.php?id=61576402916410"
    target="_blank"
    aria-label="X"
  >
    F
  </a>
  <a
    href="https://www.instagram.com/elevaterealtyuae?igsh=MTB0cGc3bXp5eGxvdQ%3D%3D"
    aria-label="Instagram"
    target="_blank"
  >
    <i className="fa-brands fa-instagram" />
  </a>
  <a
    href="https://www.linkedin.com/company/elevate-realty-uae/"
    aria-label="LinkedIn"
    target="_blank"
  >
    <i className="fa-brands fa-linkedin-in" />
  </a>
  <a
    className="footer-social-text"
    href="https://www.tiktok.com/@elevaterealtyuae"
    target="_blank"
    aria-label="TikTok"
  >
    Tt
  </a>
  <a
    href="https://www.youtube.com/@elevaterealty-uae"
    aria-label="YouTube"
    target="_blank"
  >
    <i className="fa-brands fa-youtube" />
  </a>
  
</div>

      </div>
    </div>

    <div className="footer-bottom">
      <p>© 2026 Elevate Realty. All rights reserved.</p>
      <p>Dubai H.Q. · Representative presence in Canada &amp; India</p>
    </div>
  </footer>
);

export default Footer;
